export default __webpack_public_path__ + "static/media/343.5511a447.png";